<template>
  <h-form autocomplete="off" :model="loginForm" ref="loginForm" label-position="left" class="card-box login-form">
    <div class="login-form-wrapper">
      <h-form-item prop="username" :class="{'userFocus':userFocusStatus}">
        <h-input name="username" type="text" v-model="loginForm.username" placeholder="手机号" @on-focus="handlefocus('user')"
          @on-blur="handleblur('user')" @on-change="handleChange('user')" @on-enter="handleEnter('user')" ref='username'>
          <h-icon name="icon-u-a-login-user" size="large" slot="prepend"></h-icon>
        </h-input>
        <div class="verify-tip verify-bottom" v-show='userError'>
          <div class="verify-tip-arrow"></div>
          <div class="verify-tip-inner">{{userErrorInfo}}</div>
        </div>
      </h-form-item>
      <h-form-item prop="checkcode" :class="{'checkFocus':checkFocusStatus}">
        <h-input @on-enter="handleLogin" @on-focus="handlefocus('check')" @on-blur="handleblur('check')" name="checkcode" type="text" :specialFilter="true" :specialLength="6" :specialDecimal="0"
          v-model="loginForm.checkcode" autocomplete="on" :placeholder="$t('m.i.common.checkcode')" class="checkInput" style="width: 258px;"
          ref='check'>
          <h-icon name="u-a-chk" slot="prepend"></h-icon>
        </h-input>
        <div class="checkcode">
          <span @click="createCode" :class="{'has-send-code':codeTimer}">{{secondsText}}</span>
        </div>
        <div class="verify-tip verify-bottom" v-show='codeError'>
          <div class="verify-tip-arrow"></div>
          <div class="verify-tip-inner">{{codeErrorInfo}}</div>
        </div>
      </h-form-item>
    </div>
    <div class="form-item-submit">
      <h-form-item style="margin-bottom: 0">
        <h-button type="primary" style="width:100%;" :loading="loading" @click.native.prevent="handleLogin" ref="submit">
          {{$t('m.i.common.login')}}
        </h-button>
      </h-form-item>
    </div>
  </h-form>
</template>
<script>
import { sendPhoneCode } from '@frame/api/login'
let phoneReg = /^1[0-9]{10}$/
export default {
  name: 'webCellPhoneLogin',
  data () {
    return {
      loginForm: {
        username: '',
        checkcode: ''
      },
      userError: false,
      userErrorInfo: '',
      codeError: false,
      codeErrorInfo: '',
      userFocusStatus: false,
      checkFocusStatus: false,
      codeTimer: null,
      secondsText: '获取验证码',
      codeCount: 60,
      loading: false
    }
  },
  watch: {
    'loginForm.checkcode': {
      handler: function () {
        this.codeError = false
      },
      deep: true
    },
    'loginForm.username': {
      handler: function () {
        this.userError = false
      },
      deep: true
    }
  },
  methods: {
    // 输入框获取焦点
    handlefocus (type) {
      if (type === 'user') {
        this.userFocusStatus = true
      }
      if (type === 'check') {
        this.checkFocusStatus = true
      }
    },
    // 输入框失去焦点
    handleblur (type) {
      if (type === 'user') {
        this.userFocusStatus = false
      }
      if (type === 'check') {
        this.checkFocusStatus = false
      }
    },
    handleChange () {

    },
    // 登录
    handleLogin () {
      if (!phoneReg.test(this.loginForm.username)) {
        this.userError = true
        this.userErrorInfo = '请输入正确的手机号'
        return
      }
      if (!this.loginForm.checkcode) {
        this.codeError = true
        this.codeErrorInfo = '请输入验证码'
        return
      }

      let param = this.loginForm
      // loginType=sms 手机号登录
      param.loginType = 'sms'
      this.loading = true
      this.$store.dispatch('loginOtp', param).then((res) => {
        if (res.errorNo === '0') {
          // 重新登录，获取导航的值，设置false，判断重新获取
          this.$store.commit('SET_DET_MENU', false)
          this.$store.dispatch('getUserImage', '')
          this.loading = false
          return this.$router.push({ path: '/uc-index' })
        }
        this.codeErrorInfo = res.errorInfo
        this.codeError = true
        this.loading = false
      }).catch(e => {
        console.error(e)
        this.loading = false
      })
    },
    // 获取手机验证码
    async createCode () {
      const _this = this
      if (_this.codeTimer) return
      if (!phoneReg.test(this.loginForm.username)) {
        this.userError = true
        this.userErrorInfo = '请输入正确的手机号'
        return
      }
      // 获取验证码
      _this.codeCount = await this.getCode()

      //发送成功-倒计时
      _this.codeTimer = setInterval(() => {
        if (_this.codeCount === 0) {
          clearInterval(_this.codeTimer)
          _this.codeCount = 60
          _this.codeTimer = null
          _this.secondsText = '获取验证码'
        } else {
          _this.secondsText = `${_this.codeCount}s后重新获取`
          _this.codeCount--
        }
      }, 1000)

    },
    // 调用接口获取验证码
    getCode () {
      const _this = this
      return new Promise((resolve, reject) => {
        let params = {
          type: 'login',
          account: '',
          userId: '',
          cellPhone: _this.loginForm.username
        }
        sendPhoneCode(params).then(res => {
          if (res.data.success) {
            if (res.data.newUser) {
              _this.userError = true
              _this.userErrorInfo = '该手机号未注册'
              return
            }
            this.$hMessage.success('验证码发送成功');
            resolve(res.data.gmtExpired || 60)
          } else {
            this.$hMessage.warning(res.data.errorInfo);
          }
        }).catch(e => {
          console.error(e.message);
        })
      })

    },
    handleEnter (type) {
      switch (type) {
        case 'user':
          this.$refs.check.focus()
          break
        case 'check':
          this.handleLogin()
          break
      }
    }
  },
  beforeDestroy () {
    if (this.codeTimer) {
      clearInterval(this.codeTimer)
      this.codeTimer = null
    }
  },
}
</script>
<style lang="scss" scoped>
.login-form-wrapper {
  .checkcode {
    cursor: pointer;
    line-height: 36px;
    color: #298dff;
    width: 82px;
    .has-send-code {
      color: #999;
      cursor: text;
    }
  }
}
</style>